module.exports = __webpack_public_path__ + "img/medium-priority.540d538f.gif";